/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MessageBanner_viewer = {
    readonly unregisteredUserMessages?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_messages">;
    } | null> | null;
    readonly previewMessages?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_messages">;
    } | null> | null;
    readonly " $refType": "MessageBanner_viewer";
};
export type MessageBanner_viewer$data = MessageBanner_viewer;
export type MessageBanner_viewer$key = {
    readonly " $data"?: MessageBanner_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"MessageBanner_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "FragmentSpread",
    "name": "MessageBannerCarousel_messages",
    "args": null
  }
];
return {
  "kind": "Fragment",
  "name": "MessageBanner_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "marketingBannerIsFirstTimeVisitor",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "marketingBannerPreviewSetId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "marketingBannerPreviewUserType",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "hasMarketingBannerPreviewVariables",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "hasUserId",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": "unregisteredUserMessages",
              "name": "messageSet",
              "storageKey": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "isFirstTimeVisitor",
                  "variableName": "marketingBannerIsFirstTimeVisitor"
                }
              ],
              "concreteType": "MessageSetModule",
              "plural": true,
              "selections": (v0/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasMarketingBannerPreviewVariables",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "previewMessages",
          "name": "messageSet",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "setId",
              "variableName": "marketingBannerPreviewSetId"
            },
            {
              "kind": "Variable",
              "name": "userType",
              "variableName": "marketingBannerPreviewUserType"
            }
          ],
          "concreteType": "MessageSetModule",
          "plural": true,
          "selections": (v0/*: any*/)
        }
      ]
    }
  ]
};
})();
(node as any).hash = '126ffb553844df86658da81e74c6f08f';
export default node;
